module.exports = __webpack_public_path__ + "media/images/master-wf-icon-nav-3de75ad9e3aaf5eb936a6adf9a970677.svg";